import { MapPin, Users, Award } from "lucide-react";
import { COMPANY } from "@/data/site";

const points = [
  {
    icon: Award,
    title: "3.5 years of focused craftsmanship",
    body: "Every system is designed, installed and commissioned by our own engineers — never sub-contracted.",
  },
  {
    icon: Users,
    title: "30 specialists in-house",
    body: "Structural designers, MEP engineers, certified electricians and after-sales technicians on payroll.",
  },
  {
    icon: MapPin,
    title: "Rooted in Bengaluru, serving Karnataka",
    body: "Sultan Palya HQ with project crews dispatched across the state — within hours, not weeks.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="section-pad relative"
    >
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <img
                data-testid="about-image"
                src="https://static.prod-images.emergentagent.com/jobs/cf5f6853-f98e-4b62-88f9-0d03d2ce960b/images/65bf23021538cb9193bd8cec3e2a95af711e39f7fc606ec327d6bf18ae0f71d1.png"
                alt="Residential solar installation"
                className="w-full aspect-[4/5] object-cover rounded-sm border border-white/10"
              />
              <div className="absolute -bottom-6 -right-6 glass px-6 py-5 rounded-sm hidden md:block">
                <div className="font-serif text-4xl text-[#FFC857] leading-none">
                  160+
                </div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#A0ABC0] mt-2">
                  Rooftops Live
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.3em] text-[#FFC857] mb-6">
              — About Jashvi Energy
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.1]">
              A Bangalore-born solar studio with{" "}
              <span className="italic text-[#FFC857]">engineering soul.</span>
            </h2>
            <p className="mt-8 text-[#A0ABC0] text-base md:text-lg font-light leading-relaxed">
              Jashvi Energy was founded to bring world-class rooftop solar to
              Karnataka without the usual compromises. We don't broker; we
              build. Our in-house team owns every step — site survey,
              structural design, panel selection, electrical integration and
              decade-long after-care — so your investment compounds quietly
              for the next 30 years.
            </p>

            <div className="mt-10 space-y-6">
              {points.map((p) => (
                <div key={p.title} className="flex gap-5">
                  <div className="shrink-0 h-12 w-12 rounded-full glass flex items-center justify-center">
                    <p.icon className="h-5 w-5 text-[#FFC857]" />
                  </div>
                  <div>
                    <div className="font-serif text-xl text-white">
                      {p.title}
                    </div>
                    <div className="text-sm text-[#A0ABC0] mt-1 font-light">
                      {p.body}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 pt-8 border-t border-white/10 text-sm text-[#A0ABC0] flex items-start gap-3">
              <MapPin className="h-4 w-4 text-[#FFC857] mt-1 shrink-0" />
              <span className="font-light leading-relaxed">
                {COMPANY.address}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
